import { moveToFulfilled, update } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { TopicsAllLoadAction, TopicsAllLoadMoreAction } from '../../domains/engageTopicsAll/actions.types';
import { TopicHeaderLoadAction } from '../../domains/topicHeaderLoad/actions.types';
import { TopicCreateFulfilledAction } from '../../domains/topics/createActions.types';
import { TopicEditAction } from '../../domains/topics/editActions.types';
import { TopicsFollowedLoadAction } from '../../domains/topicsFollowedLoad/loadActions.types';
import { TopicsFollowedLoadMoreAction } from '../../domains/topicsFollowedLoad/loadMoreActions.types';
import { TrendingTopicsLoadAction } from '../../domains/trendingTopicsLoad/loadActions.types';
import { TrendingTopicsLoadMoreAction } from '../../domains/trendingTopicsLoad/loadMoreActions.types';
import { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';
import { Topic } from '../topics/types';

import { TopicDescription, TopicDescriptions } from './types';

export type TopicDescriptionsAction =
  | TopicEditAction
  | TopicHeaderLoadAction
  | TrendingTopicsLoadAction
  | TrendingTopicsLoadMoreAction
  | TopicsAllLoadAction
  | TopicsAllLoadMoreAction
  | TopicsFollowedLoadAction
  | TopicsFollowedLoadMoreAction
  | TypeaheadFulfilledAction
  | TopicCreateFulfilledAction;

const initialState: TopicDescriptions = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const updateTopics = (state: TopicDescriptions, topics: Record<Topic['id'], Topic>) => {
  const topicsIds = Object.keys(topics);

  const topicDescriptions = topicsIds.reduce<Record<TopicDescription['id'], TopicDescription>>(
    (accum, topicId: Topic['id']) => ({
      ...accum,
      [topicId]: {
        id: topicId,
        description: topics[topicId].description || '',
        shortDescription: topics[topicId].shortDescription,
      },
    }),
    {}
  );

  return moveToFulfilled(state, topicDescriptions);
};

const reducer: Reducer<TopicDescriptions, TopicDescriptionsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'TOPIC.CREATE_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TOPIC.EDIT_FULFILLED':
      return update(state, action.payload.topicId, { description: action.payload.topic.description });
    case 'TOPIC_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.topicDescriptions);
    case 'TOPICS_ALL.LOAD_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TOPICS_ALL.LOAD_MORE_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TRENDING_TOPICS.LOAD_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TRENDING_TOPICS.LOAD_MORE_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TOPICS_FOLLOWED.LOAD_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TOPICS_FOLLOWED.LOAD_MORE_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return updateTopics(state, action.payload.entities.topics);
    default:
      return state;
  }
};

export default reducer;
